import { render, staticRenderFns } from "./SettingsTabMailTemplates.vue?vue&type=template&id=4dd9424e&scoped=true"
import script from "./SettingsTabMailTemplates.vue?vue&type=script&lang=ts"
export * from "./SettingsTabMailTemplates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd9424e",
  null
  
)

export default component.exports